// extracted by mini-css-extract-plugin
export default {"icon":"style_icon__azGDt","dark":"style_dark__QWWxQ"};